import {
  Stack,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Divider,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";

import { ReactComponent as IconDocument } from "../../../../images/iconFile.svg";

import Item from "../Item";

import "../../../PrimeiraConsulta/modulos/styles.css";

export default function AnamneseGeral({ data, small }) {
  return (
    <Accordion defaultExpanded={false} className="AccordionContainer">
      <AccordionSummary
        expandIcon={<ExpandMore style={{ color: "#1E729F" }} />}
        aria-controls="AnamneseGeral-content"
        id="AnamneseGeral-header"
        className={`AccordionSummaryContainer ${small ? "small" : ""}`}
      >
        <Stack direction="row" alignItems="center" gap="8px " height="30px">
          <IconDocument style={{ width: "24px" }} />
          <Typography className={`Accordion_title ${small ? "small" : ""}`}>
            Anamnese geral
          </Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <Stack className="template-grid column-4">
          <Item
            label="Frequência cardíaca"
            text={data.frequenciaCardiaca}
            unit={"bpm"}
          />
          <Item label="Pressão arterial" text={data.pressaoArterial} />
          <Item label="Peso atual" text={data.pesoAtual} unit={"kg"} />
          <Item label="Perda de Peso" text={data.perdaDePeso} unit={"%"} />
          <Item label="Fluência verbal" text={data.fluenciaVerbal} />
          <Item
            label="Rastreio comportamental (ECAS)"
            text={data.rastreioComportamental}
          />
          <Item label="Apatia" text={data.apatia} />
          <Item label="Status cognitivo" text={data.statusCognitivo} />
        </Stack>
        <Divider sx={{ mt: 4, mb: 4 }} />
        <Stack component="h2" className="titleSection" mb={3}>
          Função Pulmonar
        </Stack>
        <Stack className="template-grid column-4">
          <Item
            label="Capacidade Vital Forçada (CVF)"
            text={data.capacidadeVitalForcada}
            unit={"%"}
          />
          <Item
            label="Pressão Inspiratória (PI)"
            text={data.pressaoInspiratoria}
            unit={"cmH2O"}
          />
          <Item
            label="Pressão Expiratória (PE)"
            text={data.pressaoExpiratoria}
            unit={"cmH2O"}
          />
          <Item
            label="Pressão Nasal Inspiratória (SNIP)"
            text={data.pressaoNasalInspiratoria}
            unit={"cmH2O"}
          />
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
}
